import { AsyncPipe, NgClass } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { SiteDetailService } from '../../../services/site-detail.service';

@Component({
  selector: 'w3w-map',
  standalone: true,
  imports: [NgClass, AsyncPipe],
  templateUrl: './w3w-map.component.html',
  styleUrl: './w3w-map.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class W3wMapComponent implements OnInit, OnDestroy {
  @Input({ required: true }) w3w_api_key!: string;
  @Input({ required: true }) map_api_key!: string;
  public siteDetailService = inject(SiteDetailService);
  private router = inject(Router);
  private routerSubscription?: Subscription;

  ngOnInit(): void {
    // App-root singleton — close on route change (including browser back).
    this.routerSubscription = this.router.events.pipe(filter((event): event is NavigationStart => event instanceof NavigationStart)).subscribe(() => {
      if (this.siteDetailService.viewSiteMapSubject.getValue()) {
        this.siteDetailService.viewSiteMapSubject.next(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  public closeOverlay(shouldSave: boolean): void {
    this.siteDetailService.viewSiteMapSubject.next(false);
    this.siteDetailService.w3wMapCloseSubject.next(shouldSave);
  }
}
